import DateRangePicker from '@wojtekmaj/react-daterange-picker';
import PropTypes from 'prop-types';

import './style.scss';

export default function DatePickersRange(props) {
	const { onChange, value, last, label, isDisabled, mandatory } = props;

	return (
		<>
			<div className={`datepicker-row ${last ? 'datepicker-row--last' : isDisabled ? 'datepicker-row--disabled' : ''}`}>
				{label && (
					<label>
						{label} {mandatory && <sup>*</sup>}
					</label>
				)}
				<div className='datepicker-row__block'>
					<DateRangePicker onChange={onChange} value={value} clearIcon={null} calendarIcon={null} format='dd-MM-y' dayPlaceholder='DD' monthPlaceholder='MM' yearPlaceholder='YYYY' rangeDivider='to' />
				</div>
			</div>
		</>
	);
}

DatePickersRange.propTypes = {
	value: PropTypes.any,
	onChange: PropTypes.func
};

DatePickersRange.defaultProps = {
	value: '',
	onChange: () => {}
};
